import { keyframes } from '@emotion/core';
import { colors } from '../../constants.js/colors';

/** Design tokens for signup v2 (see docs/signup-v2/01-design.md §2). Only file with raw values. */
export const ob = {
    color: {
        bgPage: '#F5F3EE',
        surface: colors.white,
        subtle: '#F8FAFC',
        brand: colors.primary.dark,
        brandHover: '#0F2400',
        lime: colors.primary.main,
        lime50: '#F2FBEC',
        lime100: '#E6F6DA',
        lime200: '#CDEFB6',
        limeBorder: '#D7F2C4',
        lime700: '#3F8F12',
        text: colors.text.primary,
        body: '#4B5563',
        label: '#374151',
        muted: colors.gray.alternative,
        border: '#D1D5DB',
        borderSubtle: '#E5E7EB',
        borderHover: '#9CA3AF',
        whatsapp: '#25D366',
        whatsappHover: '#1EBE5A',
        waHeader: '#075E54',
        waChatBg: '#EFEAE2',
        waBubble: '#FFFFFF',
        waLink: '#027EB5',
        waMeta: '#667781',
        success: '#15803D',
        successDot: '#22C55E',
        error: '#C62828',
        errorBg: '#FEF2F2',
        errorBorder: '#FECACA',
        warningBg: '#FFFBEB',
        warningBorder: '#FDE68A',
        warningText: '#92400E',
        demoBg: '#FEF3C7',
        demoText: '#92400E',
        demoBorder: '#FCD34D',
        disabledBg: '#E5E7EB',
        disabledText: '#9CA3AF',
        inputDisabledBg: '#F3F4F6',
        skeleton: '#EEF0F3',
        overlay: 'rgba(255, 255, 255, 0.72)',
    },
    confetti: ['#9EE870', '#25D366', '#FDE68A', '#FCA5A5', '#A7F3D0', '#173300'],
    font: {
        heading: '"DM Sans", "Inter", sans-serif',
        body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    radius: { sm: '8px', md: '14px', lg: '16px', xl: '24px', pill: '999px' },
    shadow: {
        card: '0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06)',
        raised: '0 4px 16px rgba(16, 24, 40, 0.08)',
        cta: '0 6px 16px rgba(23, 51, 0, 0.18)',
        whatsapp: '0 6px 16px rgba(37, 211, 102, 0.28)',
        footer: '0 -8px 16px -12px rgba(16, 24, 40, 0.18)',
    },
    focusRing: '0 0 0 2px #FFFFFF, 0 0 0 4px #173300',
    focusInput: '0 0 0 3px rgba(158, 232, 112, 0.55)',
    focusInputError: '0 0 0 3px rgba(198, 40, 40, 0.18)',
    motion: {
        fast: '120ms',
        base: '200ms',
        slow: '320ms',
        ease: 'cubic-bezier(.2, 0, 0, 1)',
        pop: 'cubic-bezier(.34, 1.56, .64, 1)',
    },
    /** Same breakpoint as the app's `isTabletOrMobile` (max-width: 600px). */
    bp: { sm: '@media (min-width: 601px)', xs: '@media (min-width: 360px)' },
    hover: '@media (hover: hover)',
    reducedMotion: '@media (prefers-reduced-motion: reduce)',
    tap: '44px',
    control: '52px',
};

export const fadeSlideIn = keyframes`
    from { opacity: 0; transform: translateX(12px); }
    to { opacity: 1; transform: none; }
`;

export const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`;

export const spin = keyframes`
    to { transform: rotate(360deg); }
`;

export const pop = keyframes`
    from { opacity: 0; transform: scale(0.6); }
    to { opacity: 1; transform: scale(1); }
`;

export const pulse = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
`;

export const shimmer = keyframes`
    0% { background-position: -200px 0; }
    100% { background-position: 200px 0; }
`;

export const confettiFall = keyframes`
    0% { transform: translate3d(0, 0, 0) rotate(0) scale(0.6); opacity: 0; }
    10% { opacity: 1; }
    100% { transform: translate3d(var(--dx), var(--dy), 0) rotate(540deg) scale(1); opacity: 0; }
`;
